export const citypasswordConstants = {
	ADD_CITYPASSWORD_REQUEST: 		"ADD_CITYPASSWORD_REQUEST",
	ADD_CITYPASSWORD_SUCCESS: 		"ADD_CITYPASSWORD_SUCCESS",
	ADD_CITYPASSWORD_FAILURE: 		"ADD_CITYPASSWORD_FAILURE",
	GET_CITYPASSWORD_REQUEST: 		"GET_CITYPASSWORD_REQUEST",
	GET_CITYPASSWORD_SUCCESS: 		"GET_CITYPASSWORD_SUCCESS",
	GET_CITYPASSWORD_FAILURE: 		"GET_CITYPASSWORD_FAILURE",
	DELETE_CITYPASSWORD_REQUEST: 	"DELETE_CITYPASSWORD_REQUEST",
	DELETE_CITYPASSWORD_SUCCESS: 	"DELETE_CITYPASSWORD_SUCCESS",
	DELETE_CITYPASSWORD_FAILURE: 	"DELETE_CITYPASSWORD_FAILURE",
	STATUS_CITYPASSWORD_REQUEST: 	"STATUS_CITYPASSWORD_REQUEST",
	STATUS_CITYPASSWORD_SUCCESS: 	"STATUS_CITYPASSWORD_SUCCESS",
	STATUS_CITYPASSWORD_FAILURE: 	"STATUS_CITYPASSWORD_FAILURE",
	GET_CITYPASSWORDDETAIL_REQUEST: 	"GET_CITYPASSWORDDETAIL_REQUEST",
	GET_CITYPASSWORDDETAIL_SUCCESS: 	"GET_CITYPASSWORDDETAIL_SUCCESS",
	GET_CITYPASSWORDDETAIL_FAILURE:  "GET_CITYPASSWORDDETAIL_FAILURE",
}


// WEBPACK FOOTER //
// ./src/app/redux/constants/citypasswordConstants.js